import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { Ps } from "../services/ps.service";

@Component({
    selector: "contract-type-combobox",
    templateUrl: "psContractTypeComboBox.component.html"
})
export class PsContractTypeComboBox implements OnInit {

    //public psContractTypes = [];

    constructor(public ps: Ps) {
        //this.psContractTypes = ps.psContractTypes;
    }

    ngOnInit(): void {
        this.ps.loadPsContractTypes()
            .subscribe();
    }
}